import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
	selector: 'recommend-multimedia',
	templateUrl: './recommend-multimedia.component.html',
	styleUrls: ['./recommend-multimedia.component.scss']
})

export class RecommendMultimediaComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	userID = 0
	courseID = 0
	units: any[] = []
	unitID = 0
	lessons: any[] = []
	
	@Input() lessonID = 0
	@Input() headingID = 0

	@Input() mode = 'lesson'
	@Input() type = ''
	imageType = 'imgTypeUndefined'
	imageColor = 'color'
	videoOrder = 'relevance'
	maxResults = 10
	@Input() keywords = ''
	@Input() dialog = false
	// keywords = 'kanji, hiragana, katakana'
	// keywords = 'inteligencia artificial'

	getMultimediaLoading = false
	getMultimediaSuccess = false
	getMultimediaError = false
	getMultimediaErrorMsg = ''
	
	addMultimediaLoading = false
	addMultimediaSuccess = false
	addMultimediaError = false
	addMultimediaErrorMsg = ''

	multimediaImages: any[] = []
	multimediaVideos: any[] = []
	selectedImages: any[] = []
	selectedVideos: any[] = []
	result: any[] = []
	
	showCourseSub = new Subscription
	getMultimediaSub = new Subscription
	taskStatusCelerySub = new Subscription
	addMultimediaSub = new Subscription
	
	constructor(private dataService: ApiService, private actRoute: ActivatedRoute, private sanitizer: DomSanitizer) { }

	ngOnInit() {
		this.userID = this.dataService.getUserID()
		this.courseID = +this.actRoute.snapshot.paramMap.get('id')!
	}

	ngAfterViewInit() {
		/*
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.units = course.units
			},
			error => {
				console.log(error)
			}
		)
		*/
	}

	ngOnChanges(): void {
		
	}

	ngOnDestroy() {
		this.showCourseSub?.unsubscribe()
		this.getMultimediaSub?.unsubscribe()
		this.taskStatusCelerySub?.unsubscribe()
		this.addMultimediaSub?.unsubscribe()
	}

	reset() {
		this.multimediaImages = []
		this.multimediaVideos = []
		this.selectedImages = []
		this.selectedVideos = []
		this.getMultimediaLoading = false
		this.getMultimediaSuccess = false
		this.getMultimediaError = false
		this.addMultimediaLoading = false
		this.addMultimediaSuccess = false
		this.addMultimediaError = false
	}

	getMultimedia() {
		// console.log(this.unitID)
		// console.log(this.lessonID)
		// console.log(this.multimediaType)
		// console.log(this.multimediaKeywords)

		if (this.type == '') {
			alert('No ha seleccionado un tipo de multimedia para recomendar.')
			return
		}

		if (this.type == 'image') {
			if (this.imageType == '') {
				alert('No ha seleccionado un tipo de imagen.')
				return
			}

			if (this.imageColor == '') {
				alert('No ha seleccionado un color de imagen.')
				return
			}
		} else if (this.type == 'video') {
			if (this.videoOrder == '') {
				alert('No ha seleccionado un orden para los videos.')
				return
			}
		}

		if (this.keywords == '' || this.keywords == null) {
			alert('No ha escrito palabras clave.')
			return
		}

		this.getMultimediaLoading = true
		this.getMultimediaError = false
		this.getMultimediaSuccess = false
		this.getMultimediaErrorMsg = ''
		
		this.addMultimediaLoading = false
		this.addMultimediaSuccess = false
		this.addMultimediaError = false
		this.addMultimediaErrorMsg = ''
		
		if (this.type == 'image') {
			this.getMultimediaSub = this.dataService.googleImageSearch(this.keywords, this.maxResults, this.imageType, this.imageColor, this.headingID)
			.subscribe({
				next: (data) => {
					console.log(data)
					this.getMultimediaSuccess = true
					this.getMultimediaLoading = false
					this.getMultimediaError = false

					if (data.error) {
						this.getMultimediaSuccess = false
						this.getMultimediaError = true
						this.getMultimediaErrorMsg = data.error
					}
	
					this.multimediaImages = data
				},
				error: (e) => {
					console.log(e)
					this.getMultimediaError = true
					this.getMultimediaLoading = false
					this.getMultimediaSuccess = false
				},
			})
		} else if (this.type == 'video') {
			this.getMultimediaSub = this.dataService.youtubeVideoSearch(this.keywords, this.maxResults)
			.subscribe({
				next: (data) => {
					console.log(data)
					this.getMultimediaSuccess = true
					this.getMultimediaLoading = false
					this.getMultimediaError = false

					if (data.error) {
						this.getMultimediaSuccess = false
						this.getMultimediaError = true
						this.getMultimediaErrorMsg = data.error
					}

					this.multimediaVideos = data

					/*
					let videoList = data
					videoList.forEach((video: any) => {
						video.link = this.sanitizer.bypassSecurityTrustResourceUrl(video.link)
						video.download = false
					})
					this.multimediaVideos = videoList
					*/
				},
				error: (e) => {
					console.log(e)
					this.getMultimediaError = true
					this.getMultimediaLoading = false
					this.getMultimediaSuccess = false
				},
			})
		}
	}

	selectUnit(unitId: number): void {
		this.lessons = this.units?.find((unit) => {
			return +unitId === +unit.id
		})?.lessons!

		this.lessonID = 0
		if (this.lessons?.length === 1) {
			this.lessonID = this.lessons[0].id
		}
	}

	multimediaIndexInList(type: string, media: any) {
		let list = []
		if (type === 'image') list = this.selectedImages
		else if (type === 'video') list = this.selectedVideos
		
		let index = list.findIndex((mediaInList) => {
			return media === mediaInList
		})

		return index
	}

	multimediaList(type: string, media: any) {
		let list = []
		if (type === 'image') list = this.selectedImages
		else if (type === 'video') list = this.selectedVideos
		let index = this.multimediaIndexInList(type, media)

		if (index > -1) {
			list.splice(index, 1)
		} else {
			list.push(media)
		}
		// console.log(list)
		
		// console.log(this.selectedImages)
		// console.log(this.selectedVideos)
	}

	addMultimedia() {
		let media: any[] = []
		if (this.type === 'image') media = this.selectedImages
		else if (this.type === 'video') media = this.selectedVideos

		if (media.length == 0) {
			alert('No se ha seleccionado ningún elemento.')
			return
		}

		this.addMultimediaLoading = true
		this.addMultimediaSuccess = false
		this.addMultimediaError = false

		console.log(this.lessonID)
		console.log(this.headingID)
		console.log(this.type)
		console.log(media)
		
		this.addMultimediaSub = this.dataService.addRecommendedMultimedia(this.lessonID, this.headingID, this.type, media)
		.subscribe({
			next: (data) => {
				console.log(data)
				this.result = data
				this.addMultimediaSuccess = true
				this.addMultimediaLoading = false
				this.addMultimediaError = false
			},
			error: (e) => {
				console.log(e)
				this.addMultimediaError = true
				this.addMultimediaLoading = false
				this.addMultimediaSuccess = false
			}
		})
	}

}
